export default [
	{
		name: "sleeping",
		choices: [
			{
				name: "nope",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "irritation",
		choices: [
			{
				name: "nope",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "focus",
		choices: [
			{
				name: "nope",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "upset",
		choices: [
			{
				name: "none",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "isolate",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "headache",
		choices: [
			{
				name: "never",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "regularly",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "unhappy",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "hopeless",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "worthless",
		choices: [
			{
				name: "never",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "restless",
		choices: [
			{
				name: "never",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "concentration",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "exhausted",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "heartbeat",
		choices: [
			{
				name: "nope",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "trembling",
		choices: [
			{
				name: "no",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "mistakes",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "strains",
		choices: [
			{
				name: "no",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "unfamiliar",
		choices: [
			{
				name: "no",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "yes_a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "dizziness",
		choices: [
			{
				name: "not_at_all",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot",
				value: 3,
			},
		],
		selected: null,
	},
	{
		name: "sex",
		choices: [
			{
				name: "no",
				value: 0,
			},
			{
				name: "sometimes",
				value: 1,
			},
			{
				name: "often",
				value: 2,
			},
			{
				name: "a_lot_of_times",
				value: 3,
			},
		],
		selected: null,
	},
];


// WEBPACK FOOTER //
// ./src/resources/stress/question_mapping.js